import { brand } from "@/data/content";

// Builds a WhatsApp link if a number is configured, otherwise falls back to
// the contact page. Never invents a phone number.
export function whatsappHref(message) {
  if (!brand.whatsapp) return "/contact";
  const text = encodeURIComponent(message || "Hi HashTag, I'd like to discuss a project.");
  return `https://wa.me/${brand.whatsapp}?text=${text}`;
}

export function VerifyBadge({ className = "" }) {
  return (
    <span
      data-testid="verify-badge"
      className={`inline-block border border-accent/40 bg-accent/5 px-2 py-0.5 text-[10px] font-bold uppercase tracking-[0.15em] text-accent ${className}`}
    >
      Content required — verify
    </span>
  );
}
